import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

type CardHeaderProps = {
  error?: string | null
  title: string
  successMessage?: string
}

const CardHeader: React.FC<CardHeaderProps> = ({
  error,
  title,
  successMessage
}) => {
  return (
    <>
      <Typography variant="h2">{title}</Typography>
      {error && (
        <Alert severity="error">
          <AlertTitle m={0}>{error}</AlertTitle>
        </Alert>
      )}
      {successMessage && (
        <Alert severity="success">
          <AlertTitle m={0}>{successMessage}</AlertTitle>
        </Alert>
      )}
      {!error && !successMessage && <Box height={50} />}
    </>
  )
}

export default CardHeader
